import {useQuery} from "@tanstack/react-query";
import {readProductCategoryApi} from "../../../../api/support/common";

/**
 * 제품카테고리 목록 hook
 * @returns
 */
export const useReadProductCategory = () => {
    const res = useQuery({
        queryKey: ["readProductCategory"],
        queryFn: async () => await readProductCategoryApi(),
        // staleTime: 6000 * 10,
        select: (res) => res?.result?.CodeEntriesList
    });

    return res;
};
